
import footerBrands from "../home/footerBrands.png"

import iso from "./iso.svg"
import eugdpr from "./eugdpr.svg"
import eugdprLight from "./eugdprLight.svg"

const footerAssets = {
    footerBrands,
    iso,
    eugdpr,
    eugdprLight

}

export default footerAssets